import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonApiBody, JSONApiIndexResponse } from '@app/interfaces';
import { ChartObject } from '../interface/chart-data.interface';

@Injectable()
export class SurveyService {
    constructor(private http: HttpClient) {}

    async getSurvey(id: number): Promise<ChartObject[]> {
        return await this.http
            .get(`/v2/performanceManagement/surveys/${id}/aggregated`)
            .toPromise()
            .then((res: JSONApiIndexResponse<JsonApiBody<ChartObject>>) => {
                return res.data.map((data) => data.attributes);
            });
    }
}
